/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Util from './util'; // @namespace Ajax.Csrf

var Read = /*#__PURE__*/function () {
  function Read(cache, nextAjax) {
    this.ajax = this.ajax.bind(this);
    this.nextAjax = nextAjax;

    if (!cache.csrf) {
      cache.csrf = {};
    }

    this.tokens = cache.csrf.tokens || (cache.csrf.tokens = {});
  }

  var _proto = Read.prototype;

  _proto.ajax = function ajax(options) {
    var _this = this;

    var jqXHR = this.nextAjax(options);
    var host = Util.hostFromUrl(options.url);

    if (Util.domainExpectsCsrfToken(this.tokens, host) && !options.firehose) {
      jqXHR.done(function (data, status, xhr) {
        var tokenHeader = xhr.getResponseHeader('X-CSRF-Token');

        if (tokenHeader) {
          _this.tokens[host] = tokenHeader;
        }
      });
    }

    return jqXHR;
  };

  return Read;
}();

export default Read;